
export type Location = {
  city: string
  postal_code: string
  region_id: string
  time_zone: string
  country_id: string
  street: string
}

export type StorefrontEvent = {
  currencyId: string
  eventId: number
  hometown: string
  localEndDate: string
  localStartDate: string
  imageUrl: string
  internationalShippingAmount: number
  name: string
  regClosingDate: string
  regOpeningDate: string
  registerUrl: string
  shippingAmount: number
  timeZone: string
  url: string
  paymentProcessor: EventPaymentProcessor
  eventGoogleTagManagerKey?: string
  orgGoogleTagManagerKey?: string
  tealiumTagManagerKey?: string
  isRegistrationDisabled: boolean
}

export type HasEvent = {
  event: StorefrontEvent
}

export enum EventPaymentProcessor {
  Adyen = 'adyen',
  Stripe = 'stripe_us',
  Stripe_EU = 'stripe_eu',
}
